import React from "react";
import styles from "./HeroBloveToken.module.scss";
import Image from "next/image";

const HeroBloveToken = () => {
  return (
    <section className={styles.heroBloveToken}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            A Community Token
            <br />
            Designed to Spread{" "}
            <br/>
            <span className={styles.spanTitle}>Love & Success </span>
          </h1>
          <p className={styles.paraghraf}>
            <span>
              The supply of B-Love tokens will be controlled by a burning
              mechanism.
            </span>
            <span>Each month, 10% of the initial supply will be burned.</span>
          </p>
        </div>

        <div className={styles.image}>
          <Image
            src='/assets/Image/Beloved-Network-Official-18 1.png'
            width={420}
            height={390}
            className={styles.img}
            alt='Beloved-Network'
          />
        </div>
      </div>
    </section>
  )
};

export default HeroBloveToken;
